const OPTIONS = {}

/** STEP FOUR */

// Land
OPTIONS.zahlungsart = [
	{
		id: 0,
		name: 'per Überweisung',
		description: 'Die Rechnung erhalten Sie in Kürze per Mail',
		value: 'per Überweisung',
	},
	{
		id: 1,
		name: 'SEPA-Lastschriftverfahren',
		description: '',
		value: 'SEPA-Lastschriftverfahren',
	},
]

export default OPTIONS
